import { serializeDateFields } from 'common/utils/time';

import { AsyncSurvey, AsyncSurveyResponse } from '../types';

export const mapSurveyFromApi = (response: AsyncSurveyResponse): AsyncSurvey =>
  serializeDateFields<AsyncSurveyResponse>('publishedAt', 'dueBy')(response);
